import React from 'react';
import Box from '@mui/material/Box';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { Controller, useFormContext, ControllerRenderProps } from 'react-hook-form';
import { Error, CommonInputProps, getError } from './Common';

export const TextInput = ({
  name,
  label,
  ...rest
}: TextFieldProps & CommonInputProps) => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <OutlinedTextInput
          field={field}
          label={label}
          error={getError(name, errors)}
          {...rest}
        />
      )}
    />
  );
};

export const OutlinedTextInput = ({ field, label, error, ...rest }: TextFieldProps & { field: ControllerRenderProps }) => {
  return (
    <Box mb={2}>
      <TextField
        label={label}
        variant="outlined"
        fullWidth
        size="small"
        {...field}
        {...rest}
        error={!!error}
        autoComplete="off"
        autoCorrect="off"
        inputProps={{
          autoComplete: 'off',
        }}
      />
      {
        !!error && <Error error={error} />
      }
    </Box>
  );
};